import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import QCGuidePage from "../pages/qc-guide/page";
import SafetyGuidePage from "../pages/safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;